import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import styled from 'styled-components';
import range from 'lodash/range';
import {
  isValidPublishDate,
  isLaterDateBefore,
  LATER_PUBLISH_MINUTE_OFFSET,
} from '../../../../helpers/episodes';

class TimeListPicker extends Component {
  constructor(props) {
    super(props);

    const { hour, minute } = props.pickedTime;
    this.state = {
      hour,
      minute,
    };
  }

  componentDidMount() {
    [this.timepickerHour, this.timepickerMinute].forEach(node => {
      node.querySelectorAll('option[selected]')[0].scrollIntoView(true);
    });
  }

  setChosenTime = future => now => isValidPublishDate(future, () => now);

  isHourAvailable = hour => {
    const { pickedDate = {} } = this.props;
    const date = moment(pickedDate).add(hour, 'hour').unix();
    return isValidPublishDate(date);
  };

  isMinuteAvailable = minute => {
    const { pickedDate = {} } = this.props;
    const { hour: pickedHour } = this.state;
    const future = moment(pickedDate).add(pickedHour, 'hour').add(minute, 'minute').unix();
    const now = moment().add(LATER_PUBLISH_MINUTE_OFFSET, 'minute').endOf('minute');
    const isTimeAheadOf = this.setChosenTime(future);
    return isTimeAheadOf(now);
  };

  onTimeChange = type => {
    return evt => {
      const value = Number(evt.target.value) || 0;
      this.setState({
        [type]: value,
      }, () => {
        const { hour, minute } = this.state;
        this.props.onTimePick({
          hour,
          minute,
        });
      });
    };
  };

  render() {
    const { hour, minute } = this.state;

    const date = moment().startOf('day')
    const pickedTime = moment(date).add(hour, 'hour').add(minute, 'minute');
    const timeView = `${pickedTime.format('HH:mm')}`;

    return (
      <React.Fragment>
        <input type="text" className="form-control" value={timeView} readOnly />
        <TimeListWrapper>
          <div className="time hour">
            <div className="header">Hour</div>
            <select
              ref={ref => (this.timepickerHour = ref)}
              defaultValue={hour}
              size="5"
              onChange={this.onTimeChange('hour')}>
              {range(24).map((hour) => {
                return (
                  <option
                    disabled={!this.isHourAvailable(hour)}
                    key={`hour-${hour}`}
                    value={hour}>
                    {moment({ hour }).format('HH')}
                  </option>
                );
              })}
            </select>
          </div>
          <div className="time minute">
            <div className="header">Minutes</div>
            <select
              ref={ref => (this.timepickerMinute = ref)}
              defaultValue={minute}
              size="5"
              onChange={this.onTimeChange('minute')}>
              {range(60).map((minute) => {
                return (
                  <option
                    disabled={!this.isMinuteAvailable(minute)}
                    key={`minute-${minute}`}
                    value={minute}>
                    {moment({ minute }).format('mm')}
                  </option>
                );
              })}
            </select>
          </div>
        </TimeListWrapper>
      </React.Fragment>
    );
  }
}

const TimeListWrapper = styled.div`
  display: flex;
  box-shadow: 0 1px 3px rgba(0,0,0,.1);
  margin-bottom: 4px;

  .time {
    width: 50%;
  }

  .header {
    padding: 6px;
    border: 1px solid whitesmoke;
    font-size: 1.4rem;
    font-weight: 600;
    color: #474747;
    text-align: center;
  }
`;

TimeListPicker.propTypes = {
  pickedDate: PropTypes.object,
  pickedTime: PropTypes.object,
  onTimePick: PropTypes.func,
};

TimeListPicker.defaultProps = {
  pickedDate: moment().startOf('day'),
  pickedTime: {
    hour: Number(moment().format('HH')),
    minute: Number(moment().format('mm')),
  },
  onTimePick: () => {},
};

export default TimeListPicker;
